import React from 'react';

const TechnicalSupport = () => {
  return (
        <div className="tpi-coming-soon font-poppins">
            <h1>Coming Soon</h1>
        </div>
  );
};

export default TechnicalSupport;
